import React from 'react';
import { CardActions } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Reusable action bar component for cards
 */
const ActionBar = ({ children, ...props }) => (
  <CardActions 
    sx={{ 
      justifyContent: 'flex-end',
      borderTop: '1px solid',
      borderColor: 'divider',
      px: 2,
      py: 0.75,
      bgcolor: 'background.paper',
      ...props.sx
    }}
    onClick={(e) => e.stopPropagation()}
    {...props}
  >
    {children}
  </CardActions>
);

ActionBar.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
};

export default ActionBar;